import React, { FC, useState } from 'react';
import { BrandstakOrder } from 'shared/types/cart/Order';
import Accordion from 'components/commercetools-ui/atoms/accordion';
import OrderItem from 'components/commercetools-ui/organisms/order-items-listing/order-item';
import AccordionButton from './accordion-button';

interface Props {
  order: BrandstakOrder | undefined;
}

const ShipmentDetails: FC<Props> = ({ order }) => {
  const [open, setOpen] = useState(false);

  const toggleAccordion = () => setOpen(!open);

  return (
    <div>
      <button onClick={toggleAccordion} className="font-green p-0"></button>
      <Accordion
        className=""
        buttonClassName="w-full"
        customClosedButton={<AccordionButton open={open} toggleAccordion={toggleAccordion} />}
      >
        <div>
          {order &&
            order.shippingInfo?.deliveries?.map((delivery, index) => (
              <div key={index} className="mb-16 border">
                <div className="w-full bg-gray-200 p-12">
                  <h3>Shipment {index + 1}</h3>
                </div>

                <div className="m-8">
                  {delivery.items.map((item) => {
                    const lineItem = order?.lineItems?.find((li) => li.lineItemId === item.itemId);
                    return lineItem ? <OrderItem key={item.itemId} lineItem={lineItem} /> : <></>;
                  })}
                </div>
                <div className="p-12">
                  <div className="flex">
                    <h4 className="mr-6">{delivery.parcels.length > 1 ? 'Track Shipments:' : 'Track Shipment:'}</h4>
                    {delivery.parcels.map((parcel, parcelIndex) => (
                      <a
                        key={parcelIndex}
                        href={parcel.trackingId}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mr-16 text-[#137e57]"
                      >
                        Package {parcelIndex + 1} {parcelIndex === delivery.parcels.length - 1 ? '' : ','}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </Accordion>
    </div>
  );
};

export default ShipmentDetails;
